module.exports = __webpack_public_path__ + "img/icon_jisu.d99bc2fb.svg";